import { defineStore } from "pinia";

export const useMenuStore = defineStore({
  id: "menuStore",
  state: () => ({
    currentMenu: [],
    currentMenuItem: {},

    menuItems: [
      {
        label: "Votre intervention",
        to: "/intervention",
        onlyForQuote: false,
        children: [],
      },
      {
        label: "Pare-brise : diagnostic",
        to: "/pare-brise",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Coté concerné",
        to: "/cote-concerne",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Décalaminage",
        to: "/decalaminage",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Pare-brise : mon impact",
        to: "/pare-brise-description",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Intervention pare-brise",
        to: "/pare-brise-intervention",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Votre vehicule",
        to: "/mon-vehicule",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Vos coordonnées",
        to: "/mes-coordonnees",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Devis ou rendez-vous",
        to: "/devis-ou-rendez-vous",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Mon rendez-vous",
        onlyForQuote: false,
        to: "/mon-rendez-vous",
        parent: null,
        children: [],
      },
      {
        label: "Mon centre",
        onlyForQuote: true,
        to: "/mon-rendez-vous",
        parent: null,
        children: [],
      },
      {
        label: "Confirmation de rendez-vous",
        to: "/rendez-vous-confirme",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Mon devis",
        to: "/devis-confirme",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
      {
        label: "Récapitulatif",
        to: "/verifier-mes-informations",
        onlyForQuote: false,
        parent: null,
        children: [],
      },
    ],
  }),
  actions: {
    reset() {
      this.currentMenu.push(this.menuItems[0]);
      this.currentMenuItem = this.menuItems[0];
    },
    addMenuItem(newMenuItem) {
      if (this.currentMenu.filter(menu => menu.label === newMenuItem.label).length == 0){
        this.currentMenu.push(newMenuItem);
      }
      this.currentMenuItem = newMenuItem;
    },
    removeLastMenuItem() {
      if (this.currentMenu.length > 1) {
        this.currentMenu.pop();
      }
    },
    goToParentMenuItem(parentUrl) {
      for (const menuItem of this.currentMenu) {
        if (menuItem.to == parentUrl) {
          this.currentMenuItem = menuItem;
          break;
        }
      }
    },
    getMenuItemWithUrl(url, onlyForQuote = false) {
      if (onlyForQuote) {
        for (const menuItem of this.menuItems) {
          if (menuItem.to === url && onlyForQuote === menuItem.onlyForQuote) {
            return menuItem;
          }
        }
      }
      for (const menuItem of this.menuItems) {
        if (menuItem.to == url) {
          return menuItem;
        }
      }
    },
    goToHome() {
      this.currentMenu = []
      this.currentMenuItem = {}
    },
    countItemsInMenu() {
      return this.currentMenu.length;
    }
  },
});
